

<template>
  <div class="payuCard">
    <div class="container">
      <PayPal
        :amount="cart.adCost"
        currency="MXN"
        :client="credentials"
        env="sandbox"
        :items="myItems"
        :invoice-number="cart.adKey"
      ></PayPal>
    </div>
  </div>
</template>

<script>
import PayPal from "vue-paypal-checkout";
import { servicesAR } from "@/components/services/servicesAR";
import axios from "axios";
export default {
  data: () => ({
    credentials: {
      sandbox:
        "AadMj9feg59fLwyG0btJ5aNJdiCP-XLvILxrZ8vOMMTr_4Rk-fmgPKJ5zq0bf1P7GtldkduzxYPU8Kv0",
      production:
        "ATemucOQJJrTc5s5hW1VJcTAL3SmQoHnKF7RydO95SW6Bsa3QA4-qiLzaR_uxAyfC4bAA0Ixz42DotyB"
    },
    myItems: []
  }),
  components: {
    PayPal
  },
  props: {},
  computed: {
    cart() {
      return this.$store.state.cart;
    }
  },
  methods: {},
  created() {
    this.myItems = [
      {
        name: this.cart.adTitle,
        description: this.cart.adTitle,
        quantity: "1",
        price: this.cart.adCost,
        currency: "MXN"
      }
    ];
  }
};
</script>


